import type { CharterPricingInventoryRow } from '~/types/charterPricingInventory';

import { getCharterCabinLabel } from './charterAirports';

export const PRICING_INVENTORY_CSV_HEADERS = [
  'Date',
  'Route',
  'Cabin',
  'Available Days Before',
  'Promo Code Days Before',
  'Waitlist Seat',
  'Adult Price',
  'Child Price',
  'Infant Price',
  'Total Booked',
  'Employee (No Promo Code)',
  'Employee (Promo Code)',
  'Friends and Family',
  'Open for Sale',
];

export function getPricingInventoryCsvRows(rows: Array<CharterPricingInventoryRow>): Array<Record<string, unknown>> {
  return rows.map((row) => ({
    Date: row.date,
    Route: row.route,
    Cabin: getCharterCabinLabel(row.cabin),
    'Available Days Before': row.availableDaysBefore,
    'Promo Code Days Before': row.promoCodeDaysBefore,
    'Waitlist Seat': row.waitlistSeat,
    'Adult Price': row.adultPrice,
    'Child Price': row.childPrice,
    'Infant Price': row.infantPrice,
    'Total Booked': row.totalBooked,
    'Employee (No Promo Code)': row.employee - row.employeeWithPromoCode,
    'Employee (Promo Code)': row.employeeWithPromoCode,
    'Friends and Family': row.friendAndFamily,
    'Open for Sale': row.openForSale,
  }));
}
